import resource from '../resource';

export const cashReportApi = resource('/cash-report/');
export const shiftsApi = resource('/list-shifts/');
